import { useGetMerchantPaymentAccounts } from "../../../../hooks/queries/useMerchantQueries";

const usePaymentData = () => {
  const {
    data: paymentData,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetMerchantPaymentAccounts();

  const mobileMoneyAccounts = paymentData?.mobileMoneyAccounts || [];
  const bankAccounts = paymentData?.bankAccounts || [];
  const walletAccounts = paymentData?.walletAccounts || [];

  return {
    paymentData,
    mobileMoneyAccounts,
    bankAccounts,
    walletAccounts,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export default usePaymentData;
